import React, { useEffect, useState } from 'react';
import ResultTable from '../ResultTable/ResultTable'
import styled from 'styled-components'
import Header from '../Header/Header'
import Hash from "object-hash";
import { useHistory, useParams } from 'react-router-dom'
import { Black, Dark, Shadow, WerfenColor, White } from '../../Constants/ColorChart'
import IconWrapper from '../Icons/IconWrapper'
import DropdownMenu from '../Dropdown/DropdownMenu'
import SettingsIcon from '../Icons/Settings/Settings'
import { connect } from 'react-redux'
import { hideSearchBar, setTitleBar, showBackArrow, showDialog } from '../../../actions/ui'
import Loader from '../Loader/Loader'
import isElectron from 'is-electron'
import Dialog from "../Dialog/Dialog";

let electron;
if ( isElectron () ) {
    electron = window.require ( "electron" )
}
const ipcRenderer = electron && electron.ipcRenderer;

/*
 *  @Description:   Component that renders a playlist.
 */


const TabSection = styled.div`
  color: ${ White };
  background: ${ Dark };
  & > div {
    width: 90%;
    margin: auto;
  }
`;

const StyledDiv = styled.div`
  color: ${ White };
`;

const RelativeDiv = styled.div`
    position: relative;
    .available_offline_playlist td:last-of-type{
        width: 180px;
    }
`;

const TableWrapper = styled.div`
  margin-top: 3%;
`;


const OfflinePlaylist = ( props ) => {
    const [ selectedTab, setSelectedTab ] = useState ( null );
    const [ playlist, setPlaylist ] = useState ( {} );
    const id = useParams ().id;
    const history = useHistory ();

    useEffect ( () => {
        props.hideSearchBar ();
        props.setTitleBar ( "Offline Playlist" );
        props.showBackArrow ();
        if ( !id ) {
            history.push ( "/" );
        }

        if ( isElectron () ) {
            ipcRenderer.send ( 'getDetailsForOfflinePlaylist', id )
            ipcRenderer.on ( 'finishedGettingOfflinePlaylist', setOfflinePlaylist )
        }

        return () => {
            if ( isElectron () ) {
                ipcRenderer.off ( 'finishedGettingOfflinePlaylist', setOfflinePlaylist )
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    const setOfflinePlaylist = ( event, playlist ) => {
        // console.info("Playlist: ", playlist)
        const tabs = playlist.tabs || [];
        let total = 0;
        if ( tabs && tabs.length > 0 ) {
            playlist.tabs.forEach ( ( item ) => total += item.resources.length );
        }
        const elementCounter = total;

        const tabContextActions = convertTableDataIntoContextMenuData ( tabs );

        const result = {
            tabs,
            elementCounter,
            tabContextActions,
            entityType: "playlist",
            modificationDate: playlist.metadata.entity_changed,
            id: playlist.metadata.id || id.toString (),
            title: playlist.metadata.name || "",
            description: playlist.metadata.description || "",
            // isFav: playlist.isLikedByCurrentUser,
        }
        setPlaylist ( result );
    }

    const convertTableDataIntoContextMenuData = ( tabs ) => {
        // Sets the list of tab items to show in the playlist dropdown. Includes a default: All action.
        const tabContextActions = [];

        tabContextActions
            .push ( {
                name: "Todos",
                action: () => setSelectedTab ( null )
            } );

        tabs.map ( ( tab ) => (
            tabContextActions
                .push ( {
                    name: tab.name,
                    action: () => setSelectedTab ( tab )
                } )
        ) );
        return tabContextActions;
    }

    return (
        <StyledDiv>
            {
                JSON.stringify ( playlist ) === "{}" &&
                Object.keys ( playlist ).length === 0 &&
                <Loader
                    message="Loading"
                    primaryColor={ WerfenColor }
                    secondaryColor={ Shadow }
                    fontColor={ Black }
                    extraStyle="margin-top: 10%"
                />
            }
            {
                JSON.stringify ( playlist ) !== "{}" &&
                <>
                    <RelativeDiv className={ "RelativeDiv" }>
                        <Header
                            isPlaylist={ true }
                            upperMiniTitle={ "Offline Playlist" }
                            title={ decodeURIComponent ( playlist.title || "" ) }
                            description={ playlist.description }
                            elementCounter={ playlist.elementCounter }
                            availableOffline={ true }
                            playlist={ playlist || {} }
                            itemId={ playlist.id || id.toString () }
                            offline={ true }
                            goBack={ true }
                            // isFav={ item.isFav }
                            // actionToChangeFav={ setFavoritePlaylistStatus }
                        />

                        {
                            playlist.tabs &&
                            playlist.tabs.length > 1 &&
                            <TabSection className={ "TabSection" }>
                                <DropdownMenu id="playlist" contextActions={ playlist.tabContextActions }>
                                    <IconWrapper
                                        color={ White }
                                        fillColor={ White }
                                        width="30px"
                                        iconStyle="position: absolute; right: 10px; &:hover{ cursor: pointer }"
                                        Icon={ SettingsIcon }
                                    />
                                </DropdownMenu>

                            </TabSection>
                        }

                    </RelativeDiv>
                    <RelativeDiv>
                        {
                            selectedTab &&
                            <TableWrapper id="tableWrapper">
                                <ResultTable
                                    rowWidth={ 80 }
                                    key={ Hash ( JSON.stringify ( selectedTab ) ) }
                                    centered
                                    fieldsToShow={ [ "name", "format" ] }
                                    title={ selectedTab.name || "" }
                                    data={ selectedTab.resources || [] }
                                    type={ "available_offline_playlist" }
                                    tableUnified={false}
                                />
                            </TableWrapper>
                        }
                        {
                            !selectedTab && playlist.tabs &&
                            playlist.tabs.map ( tab => {
                                return (
                                    <TableWrapper id="tableWrapper" key={ Hash ( JSON.stringify ( tab ) ) }>
                                        <ResultTable
                                            rowWidth={ 80 }
                                            key={ Hash ( JSON.stringify ( tab ) ) }
                                            centered
                                            fieldsToShow={ [ "name", "format" ] }
                                            title={ tab.name || "" }
                                            data={ tab.resources || [] }
                                            type={ "available_offline_playlist" }
                                            tableUnified={false}
                                        />
                                    </TableWrapper>
                                )
                            } )
                        }
                    </RelativeDiv>
                </>
            }
            {
                props.dialogVisible &&
                <Dialog/>
            }
        </StyledDiv>
    );
}


const mapStateToProps = ( state ) => ( {
    session: state.session,
    dialogVisible: state.ui.dialogVisible
} );

export default connect ( mapStateToProps, {
    showDialog,
    showBackArrow,
    setTitleBar,
    hideSearchBar,
} ) ( OfflinePlaylist );
